import {Injectable} from '@angular/core';
import {CurrencyData} from '@frontend/shared';
import {ProviderOverallResult} from '../types/overall-results.types';

@Injectable({
  providedIn: 'root',
})
export class OverallResultsCostService {
  getTotalCost(providerResult: ProviderOverallResult): number {
    return providerResult.rfqTotalCostThreeYears ?? providerResult.scores.totalCostThreeYears;
  }

  getCurrencyData(providerResult: ProviderOverallResult): CurrencyData {
    return providerResult.rfqCurrencyData ?? providerResult.scores.currencyData;
  }
}
